module.exports = __webpack_public_path__ + "react-technologies.1NSGWI06.svg";